import script from "./userAgreement.vue?vue&type=script&setup=true&lang=js"
export * from "./userAgreement.vue?vue&type=script&setup=true&lang=js"

import "./userAgreement.vue?vue&type=style&index=0&id=2a15c9a6&lang=scss&scoped=true"

import exportComponent from "/www/wwwroot/manga-official-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a15c9a6"]])

export default __exports__